import saveAs from "file-saver";
import Papa from "papaparse";
import jsPDF from "jspdf";
import moment from "moment";
import _ from "lodash";
import * as XLSX from 'xlsx';
import { millisecondsToTime, SecondsToTime } from "../components/main_layout/navigation/settings/basic_configuration/reports/voiceChannel/commonindex";
import html2canvas from "html2canvas";
import { queueAnalyticsVoiceSliceActions } from "../store/slices/analytics/queueanalytics/queueAnalyticsVoiceSlice";
import store from "../store/redux-store/root_store";
import { notification } from "antd";
import autoTable from 'jspdf-autotable';
import { isJSON } from "./utils";

function formatMillisecondsTime(ms: number): string {
    const totalMinutes = Math.floor(ms / 60000); // 1 minute = 60000 ms
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const formattedHours = `${hours.toString().padStart(2, '0')}h`;
    const formattedMinutes = `${minutes.toString().padStart(2, '0')}mins`;

    return `${formattedHours} ${formattedMinutes}`;
}

function formatTimestampTo12Hour(timestamp: number): string {
    const date = new Date(timestamp);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';

    hours = hours % 12;
    hours = hours ? hours : 12; // 0 should be 12

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}${ampm}`;
}

export const progressNotify = () => {
    notification.success({
        message: `Download in progress`,
        className: "toastNotification success",
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
        </svg>,
        closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
        </svg>,
        placement: 'topRight',
        top: 70,
        duration: 2
    });
}

export const successNotify = (noti: string) => {
    notification.success({
        message: noti || 'Success',
        className: "toastNotification success",
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
        </svg>,
        closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
        </svg>,
        placement: 'topRight',
        top: 70,
        duration: 2
    });
}



export const handleExportCSV = (data: any, header: any, fileName: string) => {
    try {
        progressNotify()
        const updatedData = data?.map((elem: any) => ({
            ...elem,
            SLAAchieved: elem?.SLAAchieved ? elem?.SLAAchieved + "%" : '-',
            SLAbreached: elem?.SLAbreached ? elem?.SLAbreached + "%" : '-',
            averageResponseTime: elem?.averageResponseTime ? SecondsToTime(elem?.averageResponseTime) : 0,
            averageHandledTime: elem?.averageHandledTime ? SecondsToTime(elem?.averageHandledTime) : 0,
            MaximumHandledTime: elem?.MaximumHandledTime ? millisecondsToTime(elem?.MaximumHandledTime) : 0,
            totalACWTime: elem?.totalACWTime ? millisecondsToTime(elem?.totalACWTime) : 0,
            averageHoldtime: elem?.averageHoldtime ? SecondsToTime(elem?.averageHoldtime) : 0,
            averageQueueWaittime: elem?.averageQueueWaittime ? SecondsToTime(elem?.averageQueueWaittime) : 0,
            occupancyRate: elem?.occupancyRate ? elem?.occupancyRate + "%" : '-',
            firstChatResolution: elem?.firstChatResolution ? elem?.firstChatResolution + "%" : '-',
            totalChatDuration: elem?.totalChatDuration ? SecondsToTime(elem?.totalChatDuration) : 0,
            avgChatDuration: elem?.avgChatDuration ? SecondsToTime(elem?.avgChatDuration) : 0,
            averageQueueWaitTime: elem?.averageQueueWaitTime ? SecondsToTime(elem?.averageQueueWaitTime) : 0,
            maxiumQueueWaitTime: elem?.maxiumQueueWaitTime ? SecondsToTime(elem?.maxiumQueueWaitTime) : 0,
            talktime: elem?.talktime ? SecondsToTime(elem?.talktime) : 0,
            Talktime: elem?.Talktime ? millisecondsToTime(elem?.Talktime) : 0,
            avgSpeedofAnswer: elem?.avgSpeedofAnswer ? millisecondsToTime(elem?.avgSpeedofAnswer) : 0,
            averageHandleTime: elem?.averageHandleTime ? millisecondsToTime(elem?.averageHandleTime) : 0,
            AverageHandleTime: elem?.AverageHandleTime ? millisecondsToTime(elem?.AverageHandleTime) : 0,
            maximumHandleTime: elem?.maximumHandleTime ? millisecondsToTime(elem?.maximumHandleTime) : 0,
            averageHoldTime: elem?.averageHoldTime ? millisecondsToTime(elem?.averageHoldTime) : 0,
            callBackDuration: elem?.callBackDuration ? SecondsToTime(elem?.callBackDuration) : 0,
            avgHandlingTime: elem?.avgHandlingTime ? SecondsToTime(elem?.avgHandlingTime) : 0,
            maxHandlingTime: elem?.maxHandlingTime ? SecondsToTime(elem?.maxHandlingTime) : 0,
            totalChatduration: elem?.totalChatduration ? SecondsToTime(elem?.totalChatduration) : 0,
            avgChatduration: elem?.avgChatduration ? SecondsToTime(elem?.avgChatduration) : 0,
            TotalACW: elem?.TotalACW ? SecondsToTime(elem?.TotalACW) : 0,
            ACW: elem?.ACW ? millisecondsToTime(elem?.ACW) : 0,
            AverageresponseTime: elem?.AverageresponseTime ? SecondsToTime(elem?.AverageresponseTime) : 0,
            AverageQueueWaiting: elem?.AverageQueueWaiting ? SecondsToTime(elem?.AverageQueueWaiting) : 0,
            MaximumQueueWaiting: elem?.MaximumQueueWaiting ? SecondsToTime(elem?.MaximumQueueWaiting) : 0,
            AverageHandledTime: elem?.AverageHandledTime ? SecondsToTime(elem?.AverageHandledTime) : 0,
            occupancyrate: elem?.occupancyrate ? elem?.occupancyrate + "%" : '-',
            firstCallResolution: elem?.firstCallResolution ? elem?.firstCallResolution + "%" : '-',
            customersatisfaction: elem?.customersatisfaction ? elem?.customersatisfaction + "%" : '-',
            callbackSuccessRate: elem?.callbackSuccessRate ? elem?.callbackSuccessRate + "%" : '-',
            overallConversationRate: elem?.overallConversationRate ? elem?.overallConversationRate + "%" : '-',
            CustomerSatisfaction: elem?.customersatisfaction ? elem?.customersatisfaction + "%" : '-',
            time: elem?.time ? formatTimestampTo12Hour(elem?.time) : 0,
            duration: elem?.duration ? formatMillisecondsTime(elem?.duration) : 0,
            phoneNumber: elem?.phoneNumber ? `${elem?.phoneNumber}` : '-',
            callStatus: elem?.callStatus ? elem.callStatus : '-',
            agent: elem?.agentName ? elem.agentName : '-',
            campaignName: elem?.campaignName ? elem?.campaignName : "-",
            date: elem.date ? elem.date : '-',
            answeredCall: elem.answeredCall ? elem.answeredCall : '-',
            unansweredCall: elem.unansweredCall ? elem.unansweredCall : '-',
            busyCall: elem.busyCall ? elem.busyCall : '-',
            notTriggeredCall: elem.notTriggeredCall ? elem.notTriggeredCall : '-',
            notReachableCall: elem.notReachableCall ? elem.notReachableCall : '-',
            successRate: elem.successRate ? elem.successRate : '-',
            droppedCalls: elem.droppedCalls ? elem.droppedCalls : '-',
            averageCallDuration: elem.averageCallDuration ? elem.averageCallDuration : '-',
            totalAttempts: elem.totalAttempts ? elem.totalAttempts : '-',
            maximumEmailHandlingTime: elem?.maximumEmailHandlingTime ? millisecondsToTime(elem?.maximumEmailHandlingTime) : "-",
            AverageEmailHandlingTime: elem?.AverageEmailHandlingTime ? millisecondsToTime(elem?.AverageEmailHandlingTime) : "-",
            TotalChatDuration: elem?.TotalChatDuration ? millisecondsToTime(elem?.TotalChatDuration) : "-",
            AverageChatDuration: elem?.AverageChatDuration ? millisecondsToTime(elem?.AverageChatDuration) : "-",
            CustomerUniqueId: elem.CustomerUniqueId ? elem?.CustomerUniqueId :"-"


        }));

        const headerTitles = header.map((col: any) => col.title);

        const mappedData = updatedData.map((row: any) => {
            return headerTitles.map((title: string) => row[header.find((col: any) => col.title === title)?.dataIndex]);
        });

        const csvData = [headerTitles, ...mappedData];
        const csv = Papa.unparse(csvData);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, `${fileName}_${moment().format('DD/MM/YYYY')}.csv`);
        successNotify(`Download completed`)
    } catch (error) {
        console.log(error);
    }
};

export const handleExportPDF = async (data: any, header: any, containerRef: any, containerRef2: any, title: string, fileName: string) => {
    try {
        progressNotify();
        const getParsedNotes = (data: any) => {
            const parsedNotes = isJSON(data) ? JSON.parse(data) : null
            if (parsedNotes) {
                const res = parsedNotes?.map((n: any, i: number) => `${i + 1}. ${n.message?.trim?.() || '-'}`).join('\n');
                return res
            }
            return '-'
        }

        const updatedData = data?.map((elem: any, index: number) => ({
            ...elem,
            SLAAchieved: elem?.SLAAchieved ? elem?.SLAAchieved + "%" : '-',
            SLAbreached: elem?.SLAbreached ? elem?.SLAbreached + "%" : '-',
            averageResponseTime: elem?.averageResponseTime ? SecondsToTime(elem?.averageResponseTime) : 0,
            averageHandledTime: elem?.averageHandledTime ? SecondsToTime(elem?.averageHandledTime) : 0,
            MaximumHandledTime: elem?.MaximumHandledTime ? millisecondsToTime(elem?.MaximumHandledTime) : 0,
            totalACWTime: elem?.totalACWTime ? millisecondsToTime(elem?.totalACWTime) : 0,
            averageHoldtime: elem?.averageHoldtime ? SecondsToTime(elem?.averageHoldtime) : 0,
            averageQueueWaittime: elem?.averageQueueWaittime ? SecondsToTime(elem?.averageQueueWaittime) : 0,
            occupancyRate: elem?.occupancyRate ? elem?.occupancyRate + "%" : '-',
            firstChatResolution: elem?.firstChatResolution ? elem?.firstChatResolution + "%" : '-',
            totalChatDuration: elem?.totalChatDuration ? SecondsToTime(elem?.totalChatDuration) : 0,
            avgChatDuration: elem?.avgChatDuration ? SecondsToTime(elem?.avgChatDuration) : 0,
            averageQueueWaitTime: elem?.averageQueueWaitTime ? millisecondsToTime(elem?.averageQueueWaitTime) : 0,
            maxiumQueueWaitTime: elem?.maxiumQueueWaitTime ? SecondsToTime(elem?.maxiumQueueWaitTime) : 0,
            talktime: elem?.talktime ? millisecondsToTime(elem?.talktime) : 0,
            Talktime: elem?.Talktime ? millisecondsToTime(elem?.Talktime) : 0,
            avgSpeedofAnswer: elem?.avgSpeedofAnswer ? millisecondsToTime(elem?.avgSpeedofAnswer) : "00:00:00",
            averageHandleTime: elem?.averageHandleTime ? millisecondsToTime(elem?.averageHandleTime) : 0,
            AverageHandleTime: elem?.AverageHandleTime ? millisecondsToTime(elem?.AverageHandleTime) : 0,
            maximumHandleTime: elem?.maximumHandleTime ? millisecondsToTime(elem?.maximumHandleTime) : 0,
            averageHoldTime: elem?.averageHoldTime ? millisecondsToTime(elem?.averageHoldTime) : 0,
            callBackDuration: elem?.callBackDuration ? SecondsToTime(elem?.callBackDuration) : 0,
            avgHandlingTime: elem?.avgHandlingTime ? SecondsToTime(elem?.avgHandlingTime) : 0,
            maxHandlingTime: elem?.maxHandlingTime ? SecondsToTime(elem?.maxHandlingTime) : 0,
            totalChatduration: elem?.totalChatduration ? millisecondsToTime(elem?.totalChatduration) : 0,
            avgChatduration: elem?.avgChatduration ? SecondsToTime(elem?.avgChatduration) : 0,
            TotalACW: elem?.TotalACW ? SecondsToTime(elem?.TotalACW) : 0,
            ACW: elem?.ACW ? SecondsToTime(elem?.ACW) : 0,
            AverageresponseTime: elem?.AverageresponseTime ? millisecondsToTime(elem?.AverageresponseTime) : 0,
            AverageQueueWaiting: elem?.AverageQueueWaiting ? SecondsToTime(elem?.AverageQueueWaiting) : 0,
            MaximumQueueWaiting: elem?.MaximumQueueWaiting ? SecondsToTime(elem?.MaximumQueueWaiting) : 0,
            AverageHandledTime: elem?.AverageHandledTime ? SecondsToTime(elem?.AverageHandledTime) : 0,
            occupancyrate: elem?.occupancyrate ? elem?.occupancyrate + "%" : '-',
            firstCallResolution: elem?.firstCallResolution ? elem?.firstCallResolution + "%" : '-',
            customersatisfaction: elem?.customersatisfaction ? elem?.customersatisfaction + "%" : '-',
            callbackSuccessRate: elem?.callbackSuccessRate ? elem?.callbackSuccessRate + "%" : '-',
            overallConversationRate: elem?.overallConversationRate ? elem?.overallConversationRate + "%" : '-',
            CustomerSatisfaction: elem?.customersatisfaction ? elem?.customersatisfaction + "%" : '-',
            time: elem?.time ? formatTimestampTo12Hour(elem?.time) : 0,
            duration: elem?.duration ? formatMillisecondsTime(elem?.duration) : 0,
            phoneNumber: elem?.phoneNumber ? `${elem?.phoneNumber}` : '-',
            customerName: elem?.customerName ? `${index + 1}. ${elem?.customerName}` : '-',
            callStatus: elem?.callStatus ? elem.callStatus : '-',
            agent: elem?.agentName ? elem.agentName : '-',
            ACWTime: elem?.ACWTime ? SecondsToTime(elem?.ACWTime) : 0,
            notes: getParsedNotes(elem.notes),
            maximumEmailHandlingTime: elem?.maximumEmailHandlingTime ? millisecondsToTime(elem?.maximumEmailHandlingTime) : "-",
            AverageEmailHandlingTime: elem?.AverageEmailHandlingTime ? millisecondsToTime(elem?.AverageEmailHandlingTime) : "-",
            TotalChatDuration: elem?.TotalChatDuration ? millisecondsToTime(elem?.TotalChatDuration) : "-",
            AverageChatDuration: elem?.AverageChatDuration ? millisecondsToTime(elem?.AverageChatDuration) : "-",
            blastName: elem?.blastName ? elem?.blastName : "",
            Campaignstatus: elem.Campaignstatus ? elem.Campaignstatus : "",
            occurrenceTime: elem.occurrenceTime ? elem.occurrenceTime : "",
            timeZone: elem.timeZone ? elem.timeZone : "",
            campaignType: elem.campaignType == "1" ? "Agentless Dialling " : "Predictive Dialling ",
            callerId: elem.callerId ? elem.callerId : "-",
            TypeName: elem.TypeName ? elem.TypeName : "",
            outboundNumber: elem.outboundNumber ? elem.outboundNumber : "",
            creatorName: elem.creatorName ? elem.creatorName : "",
            CustomerUniqueId: elem.CustomerUniqueId ? elem?.CustomerUniqueId :"-"
        }));
        const mappedData = _.map(updatedData, (row) => {
            return _.map(header, (col) => {
                return {
                    title: col.title,
                    key: col.key,
                    value: row[col.dataIndex]
                };
            });
        });
        console.log('aaaaaaaaaaaaa', title)
        if (title) {
            store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(true))
            let doc = new jsPDF({
                orientation: 'landscape',
                unit: 'pt',
                format: 'a4'
            });
            const pageWidth = doc.internal.pageSize.width - 40;
            const contentWidth = pageWidth - 10;
            let isImage = '100px'
            if (containerRef && containerRef2) {
                const wrapper = document.createElement('div');
                wrapper.style.display = 'flex';
                wrapper.style.flexDirection = 'column';
                wrapper.style.gap = '20px';
                const clone1 = containerRef?.current?.cloneNode(true);
                const clone2 = containerRef2?.current?.cloneNode(true);
                if (clone1) wrapper.appendChild(clone1);
                if (clone2) wrapper.appendChild(clone2);

                wrapper.style.position = 'absolute';
                wrapper.style.top = '-9999px';
                document.body.appendChild(wrapper);

                const canvas = await html2canvas(wrapper);
                document.body.removeChild(wrapper);

                const imgData = canvas.toDataURL('image/png');
                const imgWidth = pageWidth - 20;
                const imgHeight = (canvas.height * imgWidth) / canvas.width - 100;

                const topMargin = 100;
                doc.addImage(imgData, 'PNG', 10, topMargin, imgWidth, imgHeight);
                isImage = '600px'
            }

            const finalTemplate1 = `
            <div style="width: ${contentWidth}px;">
                <div style="width: ${contentWidth}px; text-transform: capitalize;font-size: 12px">
                ${title} Analytics <div style="font-size:10px">Comprehensive Analysis of All   ${title} Performance</div>
                </div>
                <div style="padding: 0px; width: ${contentWidth}px;font-size: 10px">
                    Produced on: ${moment().format('DD/MM/YYYY HH:mm')}
                </div>
                </div>`

            const finalTemplate2 = `
            <style>
    table {
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
  font-size: 6px;
  word-break: break-word;
}
table {
  page-break-inside: avoid !important;
  break-inside: avoid !important;
}

thead, tbody, tfoot, tr, td, th {
  page-break-inside: avoid !important;
  break-inside: avoid !important;
}
thead {
  display: table-header-group;  /* repeat header on each page */
}

tfoot {
  display: table-footer-group;
}

tr {
  page-break-inside: avoid !important;
  break-inside: avoid !important;   
  height: 120px;   
}

td, th {
  border: 1px solid black;
  vertical-align: top;
  padding: 3px;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 120px;
}

span {
  white-space: normal !important;
  word-break: break-word;
}

  </style>

            <div style="width: ${contentWidth}px;margin-top: ${isImage};">              
                    <div style="padding: 10px 0px; width: ${contentWidth}px; overflow: auto">
                        <table border="1" cellpadding="3" style="width: ${contentWidth}px; border-collapse: collapse; font-size: 10px;overflow-x: auto">
                            <thead>
                            <tr style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;width: 240px;max-width:240px;height: 36px">
                                ${mappedData[0]?.map((data: any) =>
                `<td style="border: 1px solid black;background: #24cd9e;height: 36px">
                                        ${data.title}
                             </td>`).join('')}
                            </tr>
                            </thead>
                            <tbody>
                            ${mappedData?.map((row: any,) =>
                    `<tr style="height: 36px;">
                                    ${row.map((data: any,) =>
                        `<td style="border: 1px solid black;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;width: 240px;max-width:240px;height: 36px;"> <span style="display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                     overflow: hidden;
                   text-overflow: ellipsis;
}">${data.value} </span></td>`
                    ).join('')}
                                </tr>`
                ).join('')}
                            </tbody>
                        </table>
                    </div>
            </div>`

            await doc.html(finalTemplate1, {
                margin: [10, 10],
                callback: function () {
                    // doc.addPage();
                    doc.html(finalTemplate2, {
                        margin: [10, 10],
                        callback: function () {
                            doc.save(`${fileName}_${moment().format('DD/MM/YYYY')}.pdf`);
                        },
                    });
                }
            });
            store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(false))
        } else {
            const doc = new jsPDF();

            // Extract column headers
            const headers = header.map((col: any) => col.title);
            const rows = updatedData.map((row: any) => {
                return header.map((col: any) => {
                    return row[col.dataIndex]
                })
            });

            autoTable(doc, {
                head: [headers],
                body: rows,
                styles: { fontSize: 10 },
                headStyles: {
                    fillColor: '#000',
                    textColor: [255, 255, 255] // White text
                },
                margin: { top: 20 },
            });

            doc.save(fileName);
        }

        successNotify(`Download completed`)
    } catch (error) {
        console.log(error)
        store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(false))
    }
};

export const handleExportXLS = (data: any, header: any, fileName: string) => {
    try {
        progressNotify()
        store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(true))
        const updatedData = data?.map((elem: any) => {
            return {
                ...elem,
                SLAAchieved: elem?.SLAAchieved ? elem?.SLAAchieved + "%" : 0,
                SLAbreached: elem?.SLAbreached ? elem?.SLAbreached + "%" : 0,
                averageResponseTime: elem?.averageResponseTime ? SecondsToTime(elem?.averageResponseTime) : 0,
                averageHandledTime: elem?.averageHandledTime ? SecondsToTime(elem?.averageHandledTime) : 0,
                MaximumHandledTime: elem?.MaximumHandledTime ? millisecondsToTime(elem?.MaximumHandledTime) : 0,
                totalACWTime: elem?.totalACWTime ? millisecondsToTime(elem?.totalACWTime) : 0,
                averageHoldtime: elem?.averageHoldtime ? SecondsToTime(elem?.averageHoldtime) : 0,
                averageQueueWaittime: elem?.averageQueueWaittime ? SecondsToTime(elem?.averageQueueWaittime) : 0,
                occupancyRate: elem?.occupancyRate ? elem?.occupancyRate + "%" : 0,
                firstChatResolution: elem?.firstChatResolution ? elem?.firstChatResolution + "%" : 0,
                totalChatDuration: elem?.totalChatDuration ? SecondsToTime(elem?.totalChatDuration) : 0,
                avgChatDuration: elem?.avgChatDuration ? SecondsToTime(elem?.avgChatDuration) : 0,
                averageQueueWaitTime: elem?.averageQueueWaitTime ? SecondsToTime(elem?.averageQueueWaitTime) : 0,
                maxiumQueueWaitTime: elem?.maxiumQueueWaitTime ? SecondsToTime(elem?.maxiumQueueWaitTime) : 0,
                talktime: elem?.talktime ? SecondsToTime(elem?.talktime) : 0,
                Talktime: elem?.Talktime ? millisecondsToTime(elem?.Talktime) : 0,
                avgSpeedofAnswer: elem?.avgSpeedofAnswer ? SecondsToTime(elem?.avgSpeedofAnswer) : 0,
                averageHandleTime: elem?.averageHandleTime ? millisecondsToTime(elem?.averageHandleTime) : 0,
                AverageHandleTime: elem?.AverageHandleTime ? millisecondsToTime(elem?.AverageHandleTime) : 0,
                maximumHandleTime: elem?.maximumHandleTime ? millisecondsToTime(elem?.maximumHandleTime) : 0,
                averageHoldTime: elem?.averageHoldTime ? SecondsToTime(elem?.averageHoldTime) : 0,
                callBackDuration: elem?.callBackDuration ? SecondsToTime(elem?.callBackDuration) : 0,
                avgHandlingTime: elem?.avgHandlingTime ? SecondsToTime(elem?.avgHandlingTime) : 0,
                maxHandlingTime: elem?.maxHandlingTime ? SecondsToTime(elem?.maxHandlingTime) : 0,
                totalChatduration: elem?.totalChatduration ? SecondsToTime(elem?.totalChatduration) : 0,
                avgChatduration: elem?.avgChatduration ? SecondsToTime(elem?.avgChatduration) : 0,
                TotalACW: elem?.TotalACW ? SecondsToTime(elem?.TotalACW) : 0,
                ACW: elem?.ACW ? SecondsToTime(elem?.ACW) : 0,
                AverageresponseTime: elem?.AverageresponseTime ? SecondsToTime(elem?.AverageresponseTime) : 0,
                AverageQueueWaiting: elem?.AverageQueueWaiting ? SecondsToTime(elem?.AverageQueueWaiting) : 0,
                MaximumQueueWaiting: elem?.MaximumQueueWaiting ? SecondsToTime(elem?.MaximumQueueWaiting) : 0,
                AverageHandledTime: elem?.AverageHandledTime ? SecondsToTime(elem?.AverageHandledTime) : 0,
                occupancyrate: elem?.occupancyrate ? elem?.occupancyrate + "%" : 0,
                firstCallResolution: elem?.firstCallResolution ? elem?.firstCallResolution + "%" : 0,
                customersatisfaction: elem?.customersatisfaction ? elem?.customersatisfaction + "%" : 0,
                callbackSuccessRate: elem?.callbackSuccessRate ? elem?.callbackSuccessRate + "%" : 0,
                overallConversationRate: elem?.overallConversationRate ? elem?.overallConversationRate + "%" : 0,
                CustomerSatisfaction: elem?.customersatisfaction ? elem?.customersatisfaction + "%" : 0,
                time: elem?.time ? formatTimestampTo12Hour(elem?.time) : 0,
                duration: elem?.duration ? formatMillisecondsTime(elem?.duration) : 0,
                phoneNumber: elem?.phoneNumber ? `${elem?.phoneNumber}` : '-',
                callStatus: elem?.callStatus ? elem.callStatus : '',
                agent: elem?.agentName ? elem.agentName : '',
                maximumEmailHandlingTime: elem?.maximumEmailHandlingTime ? millisecondsToTime(elem?.maximumEmailHandlingTime) : "-",
                AverageEmailHandlingTime: elem?.AverageEmailHandlingTime ? millisecondsToTime(elem?.AverageEmailHandlingTime) : "-",
                TotalChatDuration: elem?.TotalChatDuration ? millisecondsToTime(elem?.TotalChatDuration) : "-",
                AverageChatDuration: elem?.AverageChatDuration ? millisecondsToTime(elem?.AverageChatDuration) : "-",
                CustomerUniqueId: elem.CustomerUniqueId ? elem?.CustomerUniqueId :"-"


            }
        })
        const mappedData = _.map(updatedData, (row) => {
            return _.map(header, (col) => {
                return {
                    title: col.title,
                    key: col.key,
                    value: row[col.dataIndex]
                };

            });
        });

        let sheetName = 'Reports&Analytics'
        const workbook = XLSX.utils.book_new();
        const sheetheader = _.map(mappedData[0], (data: any) => data.title);
        const sheetVal = _.map(mappedData, (data: any) => {
            return _.map(data, (elem: any) => elem.value)
        });
        const sheetData = [sheetheader, ...sheetVal]
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        XLSX.writeFile(workbook, `${fileName}_${moment().format('DD/MM/YYYY')}.xls`);
        store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(false))
        successNotify(`Download completed`)
    } catch (error) {
        store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(false))
        console.log(error)
    }
}

export const handleExportXLSX = (data: any, header: any, fileName: string) => {
    try {
        progressNotify()
        store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(true))

        const updatedData = data?.map((elem: any) => {
            return {
                ...elem,
                SLAAchieved: elem?.SLAAchieved ? elem?.SLAAchieved + "%" : elem?.SLAAchieved,
                SLAbreached: elem?.SLAbreached ? elem?.SLAbreached + "%" : elem?.SLAbreached,
                averageResponseTime: elem?.averageResponseTime ? SecondsToTime(elem?.averageResponseTime) : 0,
                averageHandledTime: elem?.averageHandledTime ? SecondsToTime(elem?.averageHandledTime) : 0,
                MaximumHandledTime: elem?.MaximumHandledTime ? millisecondsToTime(elem?.MaximumHandledTime) : 0,
                totalACWTime: elem?.totalACWTime ? millisecondsToTime(elem?.totalACWTime) : 0,
                averageHoldtime: elem?.averageHoldtime ? SecondsToTime(elem?.averageHoldtime) : 0,
                averageQueueWaittime: elem?.averageQueueWaittime ? SecondsToTime(elem?.averageQueueWaittime) : 0,
                occupancyRate: elem?.occupancyRate ? elem?.occupancyRate + "%" : 0,
                firstChatResolution: elem?.firstChatResolution ? elem?.firstChatResolution + "%" : 0,
                totalChatDuration: elem?.totalChatDuration ? SecondsToTime(elem?.totalChatDuration) : 0,
                avgChatDuration: elem?.avgChatDuration ? SecondsToTime(elem?.avgChatDuration) : 0,
                averageQueueWaitTime: elem?.averageQueueWaitTime ? SecondsToTime(elem?.averageQueueWaitTime) : 0,
                maxiumQueueWaitTime: elem?.maxiumQueueWaitTime ? SecondsToTime(elem?.maxiumQueueWaitTime) : 0,
                talktime: elem?.talktime ? SecondsToTime(elem?.talktime) : 0,
                Talktime: elem?.Talktime ? millisecondsToTime(elem?.Talktime) : 0,
                avgSpeedofAnswer: elem?.avgSpeedofAnswer ? SecondsToTime(elem?.avgSpeedofAnswer) : 0,
                averageHandleTime: elem?.averageHandleTime ? millisecondsToTime(elem?.averageHandleTime) : 0,
                AverageHandleTime: elem?.AverageHandleTime ? millisecondsToTime(elem?.AverageHandleTime) : 0,
                maximumHandleTime: elem?.maximumHandleTime ? millisecondsToTime(elem?.maximumHandleTime) : 0,
                averageHoldTime: elem?.averageHoldTime ? SecondsToTime(elem?.averageHoldTime) : 0,
                callBackDuration: elem?.callBackDuration ? SecondsToTime(elem?.callBackDuration) : 0,
                avgHandlingTime: elem?.avgHandlingTime ? SecondsToTime(elem?.avgHandlingTime) : 0,
                maxHandlingTime: elem?.maxHandlingTime ? SecondsToTime(elem?.maxHandlingTime) : 0,
                totalChatduration: elem?.totalChatduration ? SecondsToTime(elem?.totalChatduration) : 0,
                avgChatduration: elem?.avgChatduration ? SecondsToTime(elem?.avgChatduration) : 0,
                TotalACW: elem?.TotalACW ? SecondsToTime(elem?.TotalACW) : 0,
                ACW: elem?.ACW ? SecondsToTime(elem?.ACW) : 0,
                AverageresponseTime: elem?.AverageresponseTime ? SecondsToTime(elem?.AverageresponseTime) : 0,
                AverageQueueWaiting: elem?.AverageQueueWaiting ? SecondsToTime(elem?.AverageQueueWaiting) : 0,
                MaximumQueueWaiting: elem?.MaximumQueueWaiting ? SecondsToTime(elem?.MaximumQueueWaiting) : 0,
                AverageHandledTime: elem?.AverageHandledTime ? SecondsToTime(elem?.AverageHandledTime) : 0,
                occupancyrate: elem?.occupancyrate ? elem?.occupancyrate + "%" : 0,
                firstCallResolution: elem?.firstCallResolution ? elem?.firstCallResolution + "%" : 0,
                customersatisfaction: elem?.customersatisfaction ? elem?.customersatisfaction + "%" : 0,
                callbackSuccessRate: elem?.callbackSuccessRate ? elem?.callbackSuccessRate + "%" : 0,
                overallConversationRate: elem?.overallConversationRate ? elem?.overallConversationRate + "%" : 0,
                CustomerSatisfaction: elem?.customersatisfaction ? elem?.customersatisfaction + "%" : 0,
                time: elem?.time ? formatTimestampTo12Hour(elem?.time) : 0,
                duration: elem?.duration ? formatMillisecondsTime(elem?.duration) : 0,
                phoneNumber: elem?.phoneNumber ? `${elem?.phoneNumber}` : '-',
                callStatus: elem?.callStatus ? elem.callStatus : '',
                agent: elem?.agentName ? elem.agentName : '',
                maximumEmailHandlingTime: elem?.maximumEmailHandlingTime ? millisecondsToTime(elem?.maximumEmailHandlingTime) : "-",
                AverageEmailHandlingTime: elem?.AverageEmailHandlingTime ? millisecondsToTime(elem?.AverageEmailHandlingTime) : "-",
                TotalChatDuration: elem?.TotalChatDuration ? millisecondsToTime(elem?.TotalChatDuration) : "-",
                AverageChatDuration: elem?.AverageChatDuration ? millisecondsToTime(elem?.AverageChatDuration) : "-",
                CustomerUniqueId: elem.CustomerUniqueId ? elem?.CustomerUniqueId :"-"


            }
        })
        const mappedData = _.map(updatedData, (row) => {
            return _.map(header, (col) => {
                return {
                    title: col.title,
                    key: col.key,
                    value: row[col.dataIndex]
                };
            });
        });
        let sheetName = fileName
        const workbook = XLSX.utils.book_new();
        const sheetheader = _.map(mappedData[0], (data: any) => data.title);
        const sheetVal = _.map(mappedData, (data: any) => {
            return _.map(data, (elem: any) => elem.value)
        });
        const sheetData = [sheetheader, ...sheetVal]
        // console.log("handleExportExcel", sheetData)
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        XLSX.writeFile(workbook, `${fileName}_${moment().format('DD/MM/YYYY')}.xlsx`);
        successNotify(`Download completed`)
        store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(false))
    } catch (error) {
        store.dispatch(queueAnalyticsVoiceSliceActions.setqueueVoicePdf(false))
        console.log(error)
    }
}

export const convertOffsetToTimeZoneString = (offset: any) => {
    const sign = offset <= 0 ? "+" : "-";
    const absoluteOffset = Math.abs(offset);
    const hours = Math.floor(absoluteOffset / 60);
    const minutes = absoluteOffset % 60;
    return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}